import { CuisineCategories, CuisineTypes, RestaurantTypes } from '../../../../../modals/company/Constants';
import { Step } from '../../../../../modals/company/add-company-modal';
import { LeadSources, PosSystems } from '../../../../../modals/company/add-company-modal/BusinessDetails';
import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Rejestracja restauracji',
  description: 'Krok {{activeStep}} z {{totalSteps}}',
  steps: {
    [Step.BasicInfo]: 'Podstawowe dane',
    [Step.BusinessDetails]: 'Dane firmy',
  },
  form: {
    name: {
      label: 'Nazwa restauracji',
      placeholder: 'Wprowadź nazwę restauracji',
    },
    timezone: {
      label: 'Strefa czasowa',
      placeholder: 'Wyszukaj miasto lub strefę czasową',
      inference_failed: 'Nie udało się określić strefy czasowej dla tego adresu — wybierz ją.',
    },
    google_place: {
      label: 'Wybrane miejsce Google: {{name}}',
    },
    is_franchise: {
      label: 'Restauracja należy do marki',
    },
    sync_lieferando_brand: {
      label: 'Pobierz dane marki (logo, kolor główny) z Lieferando',
    },
    import_menu: {
      label: 'Importuj menu',
    },
    lieferando_url: {
      label: 'URL Lieferando',
      placeholder: 'URL restauracji w Lieferando',
    },
    other_platforms: {
      label: 'Aktualne platformy dostawcze',
      description: 'Wybierz wszystkie platformy, na których jesteś obecnie aktywny',
    },
    pos_system: {
      label: 'Aktualny system POS',
      placeholder: 'Wybierz system POS',
      options: {
        [PosSystems.Other]: 'Inne',
      },
    },
    delivery_mode: {
      label: 'Tryb dostawy',
      placeholder: 'Wybierz tryb dostawy',
      options: {
        [DeliveryMode.Internal]: 'Wewnętrzna (własni kierowcy)',
        [DeliveryMode.External]: 'Zewnętrzna (firma trzecia)',
      },
    },
    monthly_sales_other_platforms: {
      label: 'Miesięczna sprzedaż dostaw',
      description: 'Łączna sprzedaż na wszystkich platformach dostawczych',
      placeholder: 'Wybierz zakres sprzedaży',
      options: {
        other: 'Inne',
      },
      other: {
        placeholder: 'Wprowadź kwotę sprzedaży',
      },
    },
    lead_source: {
      label: 'Źródło leada',
      description: 'Skąd dowiedziałeś się o nas?',
      options: {
        [LeadSources.SDR]: {
          title: 'SDR',
          description: 'Pozyskanie przez przedstawiciela ds. rozwoju sprzedaży',
        },
        [LeadSources.Inbound]: {
          title: 'Przychodzący',
          description: 'Pozyskany przez stronę internetową lub marketing',
        },
        [LeadSources.Referral]: {
          title: 'Polecenie – istniejąca restauracja',
          description: 'Polecony przez jedną z naszych restauracji partnerskich',
        },
        [LeadSources.SelfGeneratedCold]: {
          title: 'Własne pozyskanie – zimny kontakt',
          description: 'Pozyskany przez cold outreach lub prospecting',
        },
        [LeadSources.SelfGeneratedReferral]: {
          title: 'Własne pozyskanie – polecenie',
          description: 'Sieć osobista lub znajomości',
        },
        [LeadSources.Tipster]: {
          title: 'Informator',
          description: 'Foodamigos płaci osobie/firmie X prowizję za polecenie',
        },
      },
    },
    sdr: {
      description: 'Wybierz SDR odpowiedzialnego za pozyskanie tego leada',
    },
    has_instagram_profile: {
      label: 'Profil Instagram',
      description: 'Czy Twoja restauracja ma profil na Instagramie?',
      options: {
        true: 'Tak',
        false: 'Nie',
      },
    },
  },
  buttons: {
    back: 'Wstecz',
    next: 'Dalej',
    complete_registration: 'Zakończ rejestrację',
  },
  basic_information: {
    title: 'Podstawowe informacje',
    description: 'Wprowadź podstawowe dane i informacje kontaktowe restauracji',
  },
  additional_options: {
    title: 'Dodatkowe opcje',
    description: 'Skonfiguruj dodatkowe ustawienia tej restauracji',
  },
  restaurant_type: {
    title: 'Typ restauracji i model obsługi',
    description: 'Wybierz format najlepiej opisujący styl obsługi tej restauracji',
  },
  cuisine_type: {
    title: 'Kategorie żywności i rodzaje kuchni',
    description: 'Wybierz wszystkie kategorie żywności i rodzaje kuchni pasujące do tej restauracji',
    placeholder: 'Szukaj rodzajów kuchni',
  },
  business_details: {
    title: 'Dane firmy',
    description: 'Pomóż nam zrozumieć Twoje obecne działania',
  },
  restaurant_types: {
    [RestaurantTypes.FullServiceRestaurant]: {
      title: 'Restauracja z pełną obsługą',
      description: 'Obsługa kelnerska przy stolikach',
    },
    [RestaurantTypes.FastCasual]: {
      title: 'Fast Casual',
      description: 'Zamówienie przy ladzie/w aplikacji, wyższa jakość niż QSR, opcjonalne miejsca siedzące',
    },
    [RestaurantTypes.QuickServiceTakeaway]: {
      title: 'Szybka obsługa (QSR) / Na wynos',
      description: 'Obsługa przy ladzie nastawiona na szybkość; głównie na wynos',
    },
    [RestaurantTypes.CafeAndBakery]: {
      title: 'Kawiarnia i piekarnia',
      description: 'Kawa, wypieki, lekkie posiłki, śniadanie/brunch',
    },
    [RestaurantTypes.DessertAndIceCream]: {
      title: 'Desery i lody',
      description: 'Koncepcje nastawione na słodycze',
    },
    [RestaurantTypes.DrinksAndBar]: {
      title: 'Napoje i bar',
      description: 'Lokale nastawione na napoje; jedzenie opcjonalne; dostawa alkoholu wg lokalnych przepisów',
    },
    [RestaurantTypes.DeliveryOnlyOrGhostKitchen]: {
      title: 'Tylko dostawa / Ghost Kitchen',
      description: 'Bez lokalu; wirtualne marki i kuchnie chmurowe',
    },
  },
  cuisine_types: {
    [CuisineTypes.Pizza]: 'Pizza',
    [CuisineTypes.Burgers]: 'Burgery',
    [CuisineTypes.ChickenFried]: 'Smażony kurczak',
    [CuisineTypes.Wings]: 'Skrzydełka',
    [CuisineTypes.KebabDoner]: 'Kebab/Döner',
    [CuisineTypes.Sandwiches]: 'Kanapki',
    [CuisineTypes.Wraps]: 'Wrapy',
    [CuisineTypes.Salads]: 'Sałatki',
    [CuisineTypes.Healthy]: 'Zdrowe',
    [CuisineTypes.Bowls]: 'Bowle',
    [CuisineTypes.Vegan]: 'Wegańskie',
    [CuisineTypes.Vegetarian]: 'Wegetariańskie',
    [CuisineTypes.GlutenFree]: 'Bez glutenu',
    [CuisineTypes.Halal]: 'Halal',

    [CuisineTypes.Sushi]: 'Sushi',
    [CuisineTypes.Japanese]: 'Japońska',
    [CuisineTypes.Ramen]: 'Ramen',
    [CuisineTypes.UdonSoba]: 'Udon/Soba',
    [CuisineTypes.Korean]: 'Koreańska',
    [CuisineTypes.KoreanFriedChicken]: 'Koreański smażony kurczak',
    [CuisineTypes.Chinese]: 'Chińska',
    [CuisineTypes.Sichuan]: 'Syczuańska',
    [CuisineTypes.CantoneseDimSum]: 'Kantońska/Dim Sum',
    [CuisineTypes.Thai]: 'Tajska',
    [CuisineTypes.Vietnamese]: 'Wietnamska',
    [CuisineTypes.Malaysian]: 'Malezyjska',
    [CuisineTypes.Indonesian]: 'Indonezyjska',
    [CuisineTypes.Filipino]: 'Filipińska',
    [CuisineTypes.Poke]: 'Poke',
    [CuisineTypes.HotPot]: 'Hot Pot',
    [CuisineTypes.DumplingsGyozaBao]: 'Dumplings/Gyoza/Bao',

    [CuisineTypes.Indian]: 'Indyjskie',
    [CuisineTypes.Biryani]: 'Biryani',
    [CuisineTypes.Pakistani]: 'Pakistańskie',
    [CuisineTypes.SriLankan]: 'Sri Lankańskie',
    [CuisineTypes.Nepalese]: 'Nepalskie',

    [CuisineTypes.Turkish]: 'Tureckie',
    [CuisineTypes.Lebanese]: 'Libańskie',
    [CuisineTypes.Syrian]: 'Syryjskie',
    [CuisineTypes.Israeli]: 'Izraelskie',
    [CuisineTypes.Egyptian]: 'Egipskie',
    [CuisineTypes.PersianIranian]: 'Perskie/Irańskie',
    [CuisineTypes.Iraqi]: 'Irackie',
    [CuisineTypes.Afghan]: 'Afgańskie',
    [CuisineTypes.ShawarmaFalafel]: 'Shawarma/Falafel',
    [CuisineTypes.MezzeGrill]: 'Mezze/Grill',
    [CuisineTypes.Greek]: 'Greckie',
    [CuisineTypes.Mediterranean]: 'Śródziemnomorskie',

    [CuisineTypes.Italian]: 'Włoskie',
    [CuisineTypes.Pasta]: 'Pasta',
    [CuisineTypes.French]: 'Francuskie',
    [CuisineTypes.SpanishTapas]: 'Hiszpańskie/Tapas',
    [CuisineTypes.Portuguese]: 'Portugalskie',
    [CuisineTypes.German]: 'Niemieckie',
    [CuisineTypes.Austrian]: 'Austriackie',
    [CuisineTypes.Balkan]: 'Bałkańskie',
    [CuisineTypes.Hungarian]: 'Węgierskie',
    [CuisineTypes.Polish]: 'Polskie',
    [CuisineTypes.Czech]: 'Czeskie',
    [CuisineTypes.Georgian]: 'Gruzińskie',

    [CuisineTypes.Mexican]: 'Meksykańskie',
    [CuisineTypes.TexMex]: 'Tex-Mex',
    [CuisineTypes.Peruvian]: 'Peruwiańskie',
    [CuisineTypes.Brazilian]: 'Brazylijskie',
    [CuisineTypes.Argentinian]: 'Argentyńskie',
    [CuisineTypes.Caribbean]: 'Karaibskie',
    [CuisineTypes.BBQAmerican]: 'BBQ/Amerykańskie',
    [CuisineTypes.Steakhouse]: 'Steakhouse',
    [CuisineTypes.AmericanGeneral]: 'Amerykańskie (Ogólne)',
    [CuisineTypes.HotDogs]: 'Hot Dogi',

    [CuisineTypes.Seafood]: 'Owoce morza',
    [CuisineTypes.FishAndChips]: 'Fish and Chips',
    [CuisineTypes.SteamedFish]: 'Ryba na parze',

    [CuisineTypes.BreakfastBrunch]: 'Śniadanie/Brunch',
    [CuisineTypes.Bagels]: 'Bajgle',
    [CuisineTypes.Bakery]: 'Piekarnia',
    [CuisineTypes.PastryDessert]: 'Wypieki/Deser',
    [CuisineTypes.WafflesCrepes]: 'Gofry/Naleśniki',
    [CuisineTypes.IceCreamGelato]: 'Lody/Gelato',
    [CuisineTypes.Donuts]: 'Donuty',
    [CuisineTypes.Cakes]: 'Ciasta',

    [CuisineTypes.CoffeeCafe]: 'Kawa/Kawiarnia',
    [CuisineTypes.BubbleTea]: 'Bubble Tea',
    [CuisineTypes.JuiceSmoothies]: 'Soki/Smoothie',
    [CuisineTypes.Milkshakes]: 'Koktajle mleczne',
    [CuisineTypes.BarPub]: 'Bar/Pub',
    [CuisineTypes.WineBar]: 'Wine Bar',
    [CuisineTypes.Cocktails]: 'Koktajle',

    [CuisineTypes.TapasMezeSmallPlates]: 'Tapas/Mezze/Małe dania',
    [CuisineTypes.Noodles]: 'Makaron',
    [CuisineTypes.Soup]: 'Zupa',
    [CuisineTypes.Schnitzel]: 'Sznycel',
    [CuisineTypes.SoulFood]: 'Soul Food',
    [CuisineTypes.ComfortFood]: 'Comfort Food',
    [CuisineTypes.StreetFood]: 'Street Food',
    [CuisineTypes.OrganicBio]: 'Organiczne/Bio',
    [CuisineTypes.KidsMenu]: 'Menu dla dzieci',
  },
  cuisine_categories: {
    [CuisineCategories.TopGeneral]: 'Ogólne',
    [CuisineCategories.AsianPacific]: 'Azja/Pacyfik',
    [CuisineCategories.SouthAsian]: 'Azja Południowa',
    [CuisineCategories.MiddleEastMediterranean]: 'Bliski Wschód/Śródziemnomorskie',
    [CuisineCategories.Europe]: 'Europa',
    [CuisineCategories.Americas]: 'Ameryki',
    [CuisineCategories.SeafoodSpecialty]: 'Specjalności rybne',
    [CuisineCategories.BreakfastBakerySweets]: 'Piekarnia śniadaniowa/Słodycze',
    [CuisineCategories.BeverageLed]: 'Napojowe',
    [CuisineCategories.OtherConcepts]: 'Inne koncepty',
  },
};
